<template>
	<div>
		<v-layout row wrap justify-end
			align-center class="header-booking-data">
			<v-flex xs2>
				<p>Nombre</p>
				<span>
					{{ booking.customer.data.name }}
					{{ booking.customer.data.lastname }}
				</span>
			</v-flex>
			<v-flex xs1 px-0>
				<p>Celular</p>
				<span>{{ phoneData }}</span>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12 text-xs-left>
				<label class="label-title">Datos de reserva</label>
			</v-flex>
			<v-flex xs12>
				<div class="bar-data">
					<div class="bar-data-item">
						<p>
							Llegada:
							<span>{{ booking.bookingStart | parseDate }}</span>
						</p>
					</div>
					<div class="bar-data-item">
						<p>
							Salida:
							<span>{{ booking.bookingEnd | parseDate }}</span>
						</p>
					</div>
					<div class="bar-data-item">
						<p>
							Número de Noches:
							<span>{{ booking.numberNights }}</span>
						</p>
					</div>
					<div class="bar-data-item">
						<p>
							Fecha de reserva:
							<span>{{ booking.bookingDate | parseDate }}</span>
						</p>
					</div>
					<div class="bar-data-item">
						<p>
							Número de Huéspedes:
							<span>{{ guestNumber }}</span>
						</p>
					</div>
					<div class="bar-data-item no-border">
						<p>
							Fuentes:
							<span>{{ channel }}</span>
						</p>
					</div>
				</div>
			</v-flex>
		</v-layout>
		<router-view
			:customer="booking.customer.data"
		></router-view>
	</div>
</template>

<script>
	import { parseDate, round } from '@/shared/filters';

	function created() {
		this.loadData();
	}

	function guestNumber() {
		return this.booking.summary.booking.adults + this.booking.summary.booking.childrens;
	}

	async function loadData() {
		const baseUrl = process.env.PMS_URL;
		const code = this.$route.params.bookingCode;
		const { data: booking } = await this.$http.get(`${baseUrl}/bookings/${code}`);
		this.booking = booking.data;
	}

	function phoneData() {
		return this.booking.customer.data.phone || this.booking.customer.data.cellPhone || '---';
	}

	function channel() {
		const channelName = this.booking.channel ? this.booking.channel.data.name : '---';
		return channelName;
	}

	function data() {
		return {
			booking: {
				channel: {
					data: {},
				},
				customer: {
					data: {},
				},
				summary: {
					booking: {},
				},
			},
		};
	}

	export default {
		name: 'prepayment',
		computed: {
			guestNumber,
			phoneData,
			channel,
		},
		created,
		data,
		filters: {
			parseDate,
			round,
		},
		methods: {
			loadData,
		},
	};
</script>

<style lang="scss" scoped>
	.header-booking-data {
		height: 31px;
		position: absolute;
		right: 20px;
		text-align: right;
		top: 54px;
		width: calc(100% - 230px);

		&-calendar {
			margin: 0px !important;
			position: static;
			width: 100%;
		}

		div {
			padding-bottom: 0px !important;
			padding-top: 0px !important;
		}

		p {
			color: map-get($colors, blue-title);
			font-family: map-get($fonts, regular);
			font-size: 10px;
			margin: 0px;
			text-transform: uppercase;
		}

		span {
			color: map-get($colors, default-skyblue);
			font-family: map-get($fonts, medium);
			font-size: 15px;
			text-transform: capitalize;
		}
	}

	.bar-data {
		align-items: center;
		background-color: white;
		box-shadow: 0 2px 5px 0 rgba($color: #000000, $alpha: .1);
		display: flex;
		height: 48px;
		justify-content: space-around;

		&-item {
			border-right: 1px solid map-get($colors, year-select);
			flex: 1 auto;

			&:last-of-type {
				border-right: 0px;
			}

			&.no-border {
				border-right: 0px;
			}

			p {
				color: map-get($colors, bg-chart);
				font-family: map-get($fonts, medium);
				font-size: map-get($sizes, fourteen);
				margin-bottom: 0px;

				span {
					color: map-get($colors, realtime-label);
					font-family: map-get($fonts, regular);
					font-size: map-get($sizes, fourteen);
				}
			}
		}

		.bar-icon {
			font-size: map-get($map: $sizes, $key: twenty);
			justify-content: flex-start;
			width: 20px;
		}
	}

	.label-title {
		font-family: map-get($fonts, semibold);
	}
</style>


// WEBPACK FOOTER //
// Prepayment.vue?8a1e3ffa